import { useContext, createContext } from 'react';

export const ModalProvider = createContext(false);

export function useModal(props) {
  return useContext(ModalProvider);
}
